<template>
    <section class="primaryInfo">
        <a name="home" style=" position: relative;top: -420px;display: block;height: 0;overflow: hidden;"></a>
        <NavCrumbs :crumbProp="crumbProp" v-show="isPc"></NavCrumbs>
       
        <section class="information">
            <section class="innerBox">
                <!-- <NewsMenu :isActive="isActive"></NewsMenu> -->
                <!-- <div class="leftMenu">
                    <li @click="gotoHandle(leftItem.anchorId)"
                        :class="['menu-item',isActive === leftItem.anchorId?'menu-item--active':'']"
                        v-for="(leftItem,idx) in leftMenus" :key="idx">
                        {{leftItem.title}}
                    </li>
                </div>  -->
                <NewsMenu :isActive="isActive"></NewsMenu>
                <NewsBar></NewsBar> 
                <div class="info" :dir="langDir">

                    <a
                        style="display: block; margin-top: 20px;"
                        class="version_label"
                        :href="
                        curLang == 'ar'
                            ? '/news-apr29-2020?lang=en'
                            : '/news-apr29-2020?lang=ar'
                        "
                        >{{ curLang == "ar" ? "English Version" : "النسخة العربية" }}</a
                    >
                     <div v-show="curLang == 'ar'">
                    <h1>احتفلوا بشهر رمضان المبارك وابقوا على تواصل عبر ToTok</h1>
                    
                        <span class="sub_date">April 29, 2020</span>
<img src="../assets/img/Ramadan1.png" alt="Ramadan Kareem" class="content_img" style="display: flex;width: 100%;margin: 30px auto;">
<p>
    بمناسبة شهر رمضان المبارك الذي نحتفي به هذا العام للمرة الأولى مع المستخدمين رغبنا بإضافة طابع مميز ومليء بالمرح على تجربة ToTok للاحتفال بالشهر الفضيل. ولهذا، نفخر بإطلاق حملة "ملتقى ToTok الرمضاني الافتراضي" التي تهدف إلى الاحتفال برمضان بأسلوب ممتع وغني بالمرح عبر
</p>
<h2>
    المسابقات والمحتوى المستوحى من التقاليد الرمضانية.
</h2>
<h3>
    احتفلوا بفنون الطهي واكسبوا الجوائز القيمة:
</h3>
<ul>
    <li>
       
        <p>
    	يمكن لعشاق الطعام المشاركة في مسابقتين مشوقتين على التطبيق: "مسابقة أفضل وصفة رمضانية" التي  تنطلق يوم 4 مايو، و"مسابقة أفضل طبق رمضاني" التي تنطلق يوم 14 مايو.
        </p>
    </li>
    <li>
      <p>	تحظى المشاركات التي تحصل على أعلى عدد من الأصوات بجوائز قيمة منها هاتف "هواوي" الذكي P40 Pro.</p>
         <img src="../assets/img/Ramadan2AR.png" alt="Contest Prizes" class="content_img" style="display: flex;width: 100%;margin: 30px auto;">
    </li>
    
</ul>
<h2>
    شاركوا أروع اللحظات
</h2>
<ul>
    <li>	ابقوا على تواصل مع أحبائكم من المنزل عبر مكالمات الفيديو عالية الدقة ومكالمات الفيديو الجماعية التي  يوفرها تطبيق ToTok، وشاركوا أروع 
        <video 
        style="width:100%;"
            webkit-playsinline="true"
            x5-video-player-type="h5"
            controls
            loop
            muted
            poster
            playsinline="true"
            autobuffer
            preload="auto"
            poster="https://static.totok.ai/pic/Cover_01_ar.jpeg"
        >
         <source src="https://static.totok.ai/video/Ramadan_01_AR.mp4" />
        </video>
    </li>
    <li>
        	بوسعكم الآن تهنئة أصدقائكم وأسركم بحلول شهر رمضان المبارك باستخدام الرمز التعبيري "رمضان كريم" في محادثات ToTok
        <video 
        style="width:100%;"
            webkit-playsinline="true"
            x5-video-player-type="h5"
            controls
            loop
            muted
            poster
            playsinline="true"
            autobuffer
            preload="auto"
            poster="https://static.totok.ai/pic/Cover_02_ar.png"
        >
         <source src="https://static.totok.ai/video/Ramadan_02_AR.mp4" />
        </video>
    </li>
    <li>
        	تضم خاصية الأخبار أحدث المستجدات المتعلقة بالشهر الفضيل مثل توقيت السحور والإفطار والإمساكية، والمبادرات المجتمعية، وغيرها.
        <video 
        style="width:100%;"
            webkit-playsinline="true"
            x5-video-player-type="h5"
            controls
            loop
            muted
            poster
            playsinline="true"
            autobuffer
            preload="auto"
            poster="https://static.totok.ai/pic/Cover_03_ar.png"
        >
         <source src="https://static.totok.ai/video/Ramadan_03_AR.mp4" />
        </video>
    </li>
</ul>
<p>للاحتفاء بحلول شهر رمضان المبارك مع  ToTok، يتعين على مستخدمي الأجهزة الذكية العاملة بنظام أندرويد تنزيل الإصدار الأحدث من التطبيق. أترغبون بثبيت ToTok؟ فقط انقروا <a href="https://totok.ai/download-android">هنا</a> لتنزيل التطبيق مجاناً. </p>
<p>مهما كانت طريقة احتفالكم بحلول شهر رمضان المبارك نتمنى لكم ولأحبائكم دوام الصحة والسعادة خلال الشهر الفضيل. </p>
<p>ودمتم بخير.</p>
<p>فريق ToTok</p>
                     </div>
                      <div v-show="curLang == 'en'">
                    <h1>Celebrate Ramadan and stay connected with ToTok</h1>
                    
                        <span class="sub_date">April 29, 2020</span>
<img src="../assets/img/Ramadan1.png" alt="Ramadan Kareem" class="content_img" style="display: flex;width: 100%;margin: 30px auto;">
<p>
    Ramadan Kareem! This is the first time that we celebrate Ramadan with our users, 
    and so we’ve thought about how to make the ToTok experience special for those observing 
    the Holy Month. We are proud to introduce the ‘ToTok Ramadan Virtual Gathering’ which aims to 
    honor the spirit of the season in a fun and light-hearted way with competitions and content 
    inspired by Ramadan traditions.
</p>
<h2>
    Celebrate Cuisine & Win Exciting Prizes
</h2>
<ul>
    <li>
       
        <p>
        ToTok foodies can participate in two enticing competitions on the app: the Best Ramadan Recipe Contest, 
        launching on May 4, and the Best Ramadan Dish Contest, launching on May 14. 
        </p>
    </li>
    <li>
       
        <p>
        The competition entries with the most votes will win great prizes, including a Huawei P40 Pro smartphone!
        </p>
         <img src="../assets/img/Ramadan2EN.png" alt="Contest Prizes" class="content_img" style="display: flex;width: 100%;margin: 30px auto;">
    </li>
    
</ul>
<h2>
    Share Memorable Moments
</h2>
<ul>
    <li>Socialize from home using ToTok’s HD video and group video calls to gather your loved ones, create memorable moments, 
        all while practicing physical distancing
        <video 
        style="width:100%;"
            webkit-playsinline="true"
            x5-video-player-type="h5"
            controls
            loop
            muted
            poster
            playsinline="true"
            autobuffer
            preload="auto"
            poster="https://static.totok.ai/pic/Cover_01_en.jpeg"
        >
         <source src="https://static.totok.ai/video/Ramadan_01_EN.mp4" />
        </video>
    </li>
    <li>
        You can now greet your family and friends on ToTok using the ‘Ramadan Kareem’ emoji rain in chats.
        <video 
        style="width:100%;"
            webkit-playsinline="true"
            x5-video-player-type="h5"
            controls
            loop
            muted
            poster
            playsinline="true"
            autobuffer
            preload="auto"
            poster="https://static.totok.ai/pic/Cover_02_en.png"
        >
         <source src="https://static.totok.ai/video/Ramadan_02_EN.mp4" />
        </video>
    </li>
    <li>
        The ToTok News feature will have the latest Ramadan updates, such as a timetable, community initiatives, and more.
        <video 
        style="width:100%;"
            webkit-playsinline="true"
            x5-video-player-type="h5"
            controls
            loop
            muted
            poster
            playsinline="true"
            autobuffer
            preload="auto"
            poster="https://static.totok.ai/pic/Cover_03_en.png"
        >
         <source src="https://static.totok.ai/video/Ramadan_03_EN.mp4" />
        </video>
    </li>
</ul>
<p>To celebrate Ramadan with ToTok, Android smartphone users should update to the latest version of the app.
     Haven’t installed ToTok yet? Just click <a href="https://totok.ai/download-android">here</a> to download for free now.</p>
     <p>However you do choose to celebrate the Holy Month, we wish you and your loved ones a healthy and happy Ramadan.</p>
<p>Sent with Love,</p>
<p>Team ToTok</p>
                     </div>
                </div>
            </section>
        </section>
        <Footer></Footer>
     <FootBanner ></FootBanner>
    </section>
</template>

<script>
import queryString from "query-string";
import NavCrumbs from '@/components/NavCrumbs.vue'
import NewsBar from '@/components/NewsBar.vue'
import NewsMenu from '@/components/NewsMenu.vue'
import FootBanner from '@/components/FootBanner.vue'
import Footer from '@/components/Footer.vue'

    export default {
        metaInfo() {
            return {
                title: 'Celebrate Ramadan and stay connected with ToTok',
                meta: [
                    {property: 'og:title', content: 'Celebrate Ramadan and stay connected with ToTok'},
                    {property:  'og:description', content: 'Celebrate Ramadan and stay connected with ToTok'},
                    {property: 'og:url', content: 'https://totok.ai/news-apr29-2020?lang=en'},
                    {property: 'og:type', content: 'website'},
                    {property: 'og:image', content: 'https://static.totok.ai/pic/preview/free_unblocked_call.png'},
                    {property: 'og:site_name', content: 'ToTok'}
                ]
            }
        },
        components: {
            NewsBar,
            NavCrumbs,
            NewsMenu,
             Footer,
            FootBanner
        },
        data() {
            return {
                langDir: "",
                showinfo: false,
                isActive: 'newsApr202029',
                crumbProp:{
                    label:"Recent News", 
                    type:"simple"
                },
                leftMenus: [
                    {
                        title: 'April 29',
                        anchorId: "newsApr202029"
                    },
                    {
                        title: 'Mar 23',
                        anchorId: "newsMar202023"
                    },
                    {
                        title: 'Mar 11',
                        anchorId: "newsMar202011"
                    },
                    {
                        title: 'Mar 05',
                        anchorId: "newsMar202005"
                    },
                    {
                        title: 'Feb 23',
                        anchorId: "newsFeb20200223"
                    },
                    {
                        title: 'Feb 20',
                        anchorId: "Feb202020"
                    },
                    {
                        title: 'Jan 05',
                        anchorId: "Jan05"
                    },
                    {
                        title: 'Dec 29',
                        anchorId: "Dec29"
                    },
                    {
                        title: 'Dec 27',
                        anchorId: "Dec27"
                    },
                    {
                        title: 'Dec 24',
                        anchorId: "Dec24"
                    },
                    {
                        title: 'Dec 23',
                        anchorId: "Dec23"
                    }
                ]
            };
        },
        computed: {
            curLang() {
                let lang =
                    queryString.parseUrl(location.href) &&
                    queryString.parseUrl(location.href).query &&
                    queryString.parseUrl(location.href).query.lang
                    ? queryString.parseUrl(location.href).query.lang
                    : navigator.language == "ar"
                    ? "ar"
                    : "en";
                this.langDir = lang == "ar" ? "rtl" : "ltr";
                return lang;
            },
            info() {
                return []
            },
            isPc(){
                 return document.body.offsetWidth > 450; 
            },isIOS() {
      return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0;
    },
        },
        methods: {
            gotoHandle(palice) {
                console.log('palice',palice)
                switch (palice) {
                    case "newsMar202023":
                        this.isActive = 'newsMar202023'
                        this.$router.push({name:'newsMar202023'})
                        break;
                    case "newsMar202011":
                        this.isActive = 'newsMar202011'
                        this.$router.push({name:'newsMar202011'})
                        break;
                    case "newsMar202005":
                        this.isActive = 'newsMar202005'
                        this.$router.push({name:'newsMar202005'})
                        break;
                    case "newsFeb20200223":
                        this.isActive = 'newsFeb20200223'
                        this.$router.push({name:'newsFeb20200223'})
                        break;
                    case "Feb202020":
                        this.isActive = 'Feb202020'
                        this.$router.push({name:'newsFeb202020'})
                        // this.mainPannel.scrollTo(0, 2000)
                        break;
                    case "Jan05":
                        this.isActive = 'Jan05'
                        this.$router.push({name:'newsJan05'})
                        // this.mainPannel.scrollTo(0, 2000)
                        break;
                    case "Dec29":
                        this.isActive = 'Dec29'
                        this.$router.push({name:'newsDec29'})
                        // this.mainPannel.scrollTo(0, 2000)
                        break;
                    case "Dec27":
                        this.isActive = 'Dec27'
                        this.$router.push({name:'newsDec27'})
                        // this.mainPannel.scrollTo(0, 2000)
                        break;
                    case "Dec24":
                        this.isActive = 'Dec24'
                        this.$router.push({name:'newsDec24'})
                        // this.mainPannel.scrollTo(0, 2000)
                        break;
                     case "Dec23":
                        this.isActive = 'Dec23'
                        // this.$router.push({name:'newsDec22'})
                        // this.mainPannel.scrollTo(0, 0)
                        this.$router.push({name:'newsDec22'})
                        break;
                    
                }
            }
        }
    }
</script>
<style scoped lang="stylus">

      @media only screen and (max-width: 700px) {
        .primaryInfo {
            // padding: 0.8rem;
            background: #fff;
            height: 106vh;
            .innerBox {
                padding-bottom: 50px; 
            }
            .leftMenu {
                display none
            }

            div {
                margin-left: 20px;
                margin-right: 20px;
            }

            .info {


                h1 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 28px;
                    font-weight: 400;
                    color: #222222;
                    -webkit-font-smoothing: antialiased;
                    padding-bottom: 20px;
                    padding-top: 40px;
                    margin: 0px;
                    line-height: 40px;
                }

                h2 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 24px;
                    font-weight: 400;
                    color: #4377f2;
                    -webkit-font-smoothing: antialiased;
                    padding-bottom: 18px;
                    padding-top: 28px;
                    margin: 0px;
                }

                h3 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: 400;
                    color: #808080;
                    padding-bottom: 20px;
                    margin: 0;
                }

                h6 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-style: italic;
                    font-size: 16px;
                    font-weight: bold;
                    margin-bottom: 12px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                p {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-bottom: 12px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                ul {
                    list-style: disc;
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-top: 0;
                    margin-bottom: 10px;
                    // margin-left: 24px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                li {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-top: 0px;
                    margin-bottom: 10px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                    // margin-left: 20px;
                }

                a {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-bottom: 12px;
                    color: #4377f2;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }
            }
        }

        .cp {
            height: 3.5rem;
            font-size: 13px;
            color: #808080;
            line-height: 3.5rem;
            text-align: center;
        }
    }

    @media only screen and (min-width: 701px) {
        .primaryInfo {
            padding-top: 102px;
            width: 100vw;
            background: #fff;

            .information {
                margin: 0 auto;
                width: 800px;

                .innerBox {
                    position relative;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: flex-end;
                    height: 83vh;
                    overflow: auto;
                        

                    .leftMenu {
                        position: absolute;
                        left: 0px;
                        top: 39px;
                        display flex;
                        flex-direction column;
                        justify-content center;
                        align-items: flex-start;
                        list-style none;

                        .menu-item {
                            color: #979797;
                            margin-top: 30px;
                            cursor pointer;
                            text-decoration none;
                            font-size: 15px;
                        }

                        .menu-item:nth-child(1) {
                            margin-top: 0px;
                        }

                        .menu-item--active {
                            color: #000;
                            border-bottom: 2px solid #4377f2;
                        }

                    }
                }
            }

            .info {
                width: 550px;
                margin: 20px 0;
margin-bottom:60px;
                h1 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 28px;
                    font-weight: 400;
                    color: #222222;
                    -webkit-font-smoothing: antialiased;
                    padding-bottom: 20px;
                    padding-top: 20px;
                    margin: 0px;
                    line-height: 40px;
                }

                h2 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 24px;
                    font-weight: 400;
                    color: #4377f2;
                    -webkit-font-smoothing: antialiased;
                    padding-bottom: 18px;
                    padding-top: 28px;
                    margin: 0px;
                }

                h3 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: 400;
                    color: #808080;
                    padding-bottom: 20px;
                    margin: 0;
                }

                h6 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-style: italic;
                    font-size: 16px;
                    font-weight: bold;
                    margin-bottom: 12px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                p {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-bottom: 12px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                ul {
                    list-style: disc;
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-top: 0;
                    margin-bottom: 10px;
                    margin-left: 24px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                li {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-top: 0px;
                    margin-bottom: 10px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                    margin-left: 20px;
                }

                a {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-bottom: 12px;
                    color: #4377f2;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }
            }
        }

        .cp {
            height: 70px; 
            font-size: 13px;
            color: #808080;
            line-height: 70px;
            text-align: center;
        }
    }
</style>